module.exports = __webpack_public_path__ + "img/logo-1.a00ece9d.png";